import { FC } from 'react';
import { Control, useWatch } from 'react-hook-form';

import FormField from '@/components/Forms/FormField';

interface Props {
  control: Control<any>;
}

const AutoCommentFields: FC<Props> = ({ control }) => {
  const enabled = useWatch({ control, name: 'use_auto_comment' }) as boolean;

  return (
    <>
      <FormField
        headline="Post delayed comment"
        control={control}
        name="use_auto_comment"
        type="switch"
      />
      {enabled && (
        <>
          <FormField
            label="Delayed Comment"
            type="textarea"
            control={control}
            placeholder="Add comment"
            name="auto_comment"
          />
          <FormField
            label="Comment Delay"
            subLabel="(in hours)"
            type="integer"
            control={control}
            placeholder="Add delay"
            name="auto_comment_delay"
          />
        </>
      )}
    </>
  );
};

export default AutoCommentFields;
